import { useEffect } from "react";
import Link from "next/link";
import styles from "./index.module.scss";

export default function ReviewsVidget({ isShowTitle = true }) {
  useEffect(() => {
    // Загружаем скрипт только на клиенте
    const script = document.createElement("script");
    script.src = "https://myreviews.dev/widget/dist/index.js";
    script.defer = true;
    script.onload = () => {
      if (window.myReviews) {
        new window.myReviews.BlockWidget({
          uuid: "db584884-c470-4333-b4b9-7af519320813",
          name: "g437952",
          additionalFrame: "none",
          lang: "ru",
          widgetId: "3",
        }).init();
      }
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className={styles.News}>
      {isShowTitle && (
        <h2>
          Отзывы о нас <Link href="/reviews/">Все отзывы</Link>
        </h2>
      )}
      <div>
        <iframe
          title="Виджет с отзывами «Карусель» от MyReviews"
          id="myReviews__block-widget"
        ></iframe>
      </div>
    </div>
  );
}
